import { STORAGE_DECORATOR_WARN_PREFIX } from 'core/site/constants';

/**
 * При включённом запрете на сохранение данных на устройстве
 * приложение падает с ошибкой.
 *
 * В связи с этим создаём декоратор с try {} catch {} блоком для
 * взаимодействия со сториджами.
 */
export default class StorageDecorator {
  constructor(storageType) {
    let ls;
    try {
      ls = window[storageType];
    } catch (error) {
      if (process.env.NODE_ENV === 'test') return;
      console.warn(`${STORAGE_DECORATOR_WARN_PREFIX} - ${storageType}`);
    }
    this.storage = ls;
  }

  getItem(value) {
    if (this.storage) {
      return this.storage.getItem(value);
    }
    return null;
  }

  setItem(name, value) {
    this.storage && this.storage.setItem(name, value);
  }

  removeItem(name) {
    try {
      this.storage && this.storage.removeItem(name);
    } catch (error) {
      console.error(error);
    }
  }
}
